export default function normalizeDateString(date) {
  if (!date) return null;

  let d;

  // ✅ Firestore Timestamp object
  if (typeof date.toDate === "function") {
    d = date.toDate();

    // ✅ Firestore-like { seconds, nanoseconds } object
  } else if (date.seconds) {
    d = new Date(date.seconds * 1000);

    // ✅ Already a Date object or ISO string
  } else {
    d = new Date(date);
  }

  // ✅ If still invalid
  if (isNaN(d.getTime())) return null;

  // ✅ Return YYYY-MM-DD
  return d.toISOString().split("T")[0];
}
